import { ForwardedRef, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, SelectOption } from '@components/select';
import { GENRE_FEMALE, GENRE_MALE, GENRE_NON_BINARY, GENRE_NOT_TO_SAY } from '@constants/global';

import { InputGenderProps } from './input-gender.type';

const options = [GENRE_NOT_TO_SAY, GENRE_MALE, GENRE_FEMALE, GENRE_NON_BINARY];
export const InputGender = forwardRef(
  (
    { name, hasError, selectFontLight, required, id, disabled, readOnly, ...props }: InputGenderProps,
    ref: ForwardedRef<HTMLSelectElement>
  ) => {
    const { t } = useTranslation();
    return (
      <Select
        {...props}
        ref={ref}
        id={id}
        name={name}
        data-testid='gender-input'
        hasError={hasError}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        selectFontLight={selectFontLight}>
        {options.map((option, idx) => (
          <SelectOption
            key={`${option}-${idx}`}
            data-testid={`gender-option-${option}`}
            value={option}
            label={t(`${option}InputGenderOption`)}
          />
        ))}
      </Select>
    );
  }
);
